import Api_Usermanagement from '../../api-usermanagement'

const api = new Api_Usermanagement().init()

const downloadTemplate = (modul) => {
    return api.get(`/approval-level/${modul}/export-template-excel`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    })
}

const importData = (data, lang) => {
    return api.post(`/approval-level/import?lang=${lang}`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    })
}

const exportData = (filter, module) => {
    const queryString = new URLSearchParams(filter).toString();
    return api.get(`/approval-level/export/${module}?${queryString}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    })
}

export {
    downloadTemplate,
    importData,
    exportData
}